const footerMobile = () => {
  let subLink = document.querySelectorAll('.footer__sublinks');
  let showMore = document.querySelectorAll('.has-more');

  for(let x = 0; x < showMore.length; x++) {
    if(showMore[x] != undefined) {
      showMore[x].addEventListener('click', () => {
        if(subLink[x].classList.contains('show')) {
          subLink[x].classList.remove('show');
        }
        else {
          subLink[x].classList.add('show');
        }
      })
    }
  }
}

export default footerMobile